import axios from 'axios';
import { ascvdUrl } from 'constants/urls';

export const ascvdApi = ({ data }) => {
  return axios.post(ascvdUrl, { ...data, race: 0 });
};
